/**
 * NC-specific field change handler. Updates yearFormData and syncs formData.
 * Isolated so NC changes cannot affect MAS Direct/Indirect.
 */
import type { NCFieldChangeDeps } from './ncFieldHandlers.types';

export function applyNCFieldChange(
  fieldName: string,
  processedValue: any,
  deps: NCFieldChangeDeps
): void {
  const {
    activePackSizeTab,
    activeYearTab,
    yearFormData,
    formData,
    setYearFormData,
    yearFormDataRef,
    setFormData,
    isGlobalField,
    isGsmsHndlgType,
    isDirectProduct,
  } = deps;

  if (!isGlobalField || (isGsmsHndlgType && isDirectProduct)) {
    const currentYearData =
      activePackSizeTab !== null
        ? yearFormData[activePackSizeTab]?.[activeYearTab] || formData || {}
        : formData || {};
    const { suggested_bid_price: _suggested_bid_price, ...cleanedYearData } = currentYearData;
    const updatedYearData = { ...cleanedYearData, [fieldName]: processedValue };

    setYearFormData(prev => {
      if (activePackSizeTab === null) return prev;
      return {
        ...prev,
        [activePackSizeTab]: {
          ...prev[activePackSizeTab],
          [activeYearTab]: updatedYearData,
        },
      };
    });
    if (activePackSizeTab !== null) {
      yearFormDataRef.current = {
        ...yearFormDataRef.current,
        [activePackSizeTab]: {
          ...yearFormDataRef.current[activePackSizeTab],
          [activeYearTab]: updatedYearData,
        },
      };
    }
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      ...updatedYearData,
      contracts: prevFormData.contracts,
      contractsData: prevFormData.contractsData,
      supplierName: prevFormData.supplierName,
      analysisDate: prevFormData.analysisDate,
      targetLaunchDate: prevFormData.targetLaunchDate,
      analysisType: prevFormData.analysisType,
      productName: prevFormData.productName,
      analystName: prevFormData.analystName,
    }));
  } else if (fieldName === 'analysisDate') {
    setYearFormData(prev => {
      const updated = { ...prev };
      if (activePackSizeTab !== null && updated[activePackSizeTab]?.[activeYearTab]) {
        const { analysisDate: _analysisDateY, ...rest } =
          updated[activePackSizeTab][activeYearTab];
        updated[activePackSizeTab] = {
          ...updated[activePackSizeTab],
          [activeYearTab]: rest,
        };
      }
      return updated;
    });
  }
}
